/* La Silvretta: lens-view slider and product option picker */
(function () {
  function initLensView(root) {
    if (root.dataset.lsReady) return;
    root.dataset.lsReady = '1';
    var frame = root.querySelector('.ls-lv__frame');
    var range = root.querySelector('.ls-lv__range');
    if (!frame || !range) return;
    function set(v) { frame.style.setProperty('--pos', v + '%'); }
    set(range.value || 50);
    range.addEventListener('input', function () { root.classList.add('is-touched'); set(range.value); });
  }

  function initBuy(root) {
    if (root.dataset.lsReady) return;
    root.dataset.lsReady = '1';
    var idInput = root.querySelector('input[name="id"]');
    var btn = root.querySelector('[data-ls-submit]');
    var price = root.querySelector('[data-ls-price]');
    root.querySelectorAll('input[name="ls-variant"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        idInput.value = r.value;
        if (btn) btn.textContent = r.dataset.available === 'true' ? r.dataset.cta : btn.textContent;
        if (price) price.textContent = r.dataset.price;
        if (btn) btn.disabled = r.dataset.available !== 'true';
        var url = new URL(window.location.href);
        url.searchParams.set('variant', r.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ls-lens-view]').forEach(initLensView);
    (scope || document).querySelectorAll('[data-ls-buy]').forEach(initBuy);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();